import React from "react";
import classNames from "classnames";

const VARIANT_CLASSES = {
  green: {
    default: "bg-[#23B89A] text-white",
    hover: "hover:bg-[#F9FAFB] hover:text-[#228C80]",
    disabled: "bg-[#BBDFDB] text-white cursor-not-allowed",
  },
  white: {
    default: "bg-white text-black border border-[#23B89A]",
    hover: "hover:bg-[#228C80] hover:text-white",
    disabled: "bg-[#BBDFDB] text-white  cursor-not-allowed",
  },
  gray: {
    default: "bg-[#EDEDED] text-black",
    hover: "hover:bg-[#BDBBBC] hover:text-white",
    disabled: "bg-[#EDEDED] text-[#D1D1D1] cursor-not-allowed",
  },
  red: {
    default: "bg-red-500 text-white",
    hover: "hover:bg-red-600",
    disabled: "bg-red-300 text-white cursor-not-allowed",
  },
};

const SimpleButton = ({
  text,
  onClick,
  disabled = false,
  className = "",
  variant = "green", // "green" | "white" | "gray" | "red"
}) => {
  const handlerOnClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  const variantClass = VARIANT_CLASSES[variant];

  return (
    <div
      onClick={handlerOnClick}
      className={classNames(
        "rounded-[10px] h-[54px] max-w-[300px] flex flex-1 items-center justify-center text-[16px] font-[600] transition-all duration-200",
        !disabled
          ? `${variantClass.default} ${variantClass.hover}`
          : variantClass.disabled,
        className
      )}
    >
      <span className="truncate whitespace-nowrap overflow-hidden w-full text-center">
        {text}
      </span>
    </div>
  );
};

export default SimpleButton;
